import React, { createContext, useContext, useState, useEffect } from 'react';

const EnhancedThemeContext = createContext();

export const EnhancedThemeProvider = ({ children }) => {
  const [isEnhancedTheme, setIsEnhancedTheme] = useState(() => {
    try {
      const saved = localStorage.getItem('enhancedTheme');
      return saved ? JSON.parse(saved) : true; // Default to enabled
    } catch {
      return true;
    }
  });

  useEffect(() => {
    // Apply or remove the enhanced-theme class from the document
    if (isEnhancedTheme) {
      document.documentElement.classList.add('enhanced-theme');
    } else {
      document.documentElement.classList.remove('enhanced-theme');
    }

    try {
      localStorage.setItem('enhancedTheme', JSON.stringify(isEnhancedTheme));
    } catch (error) {
      console.error('Error saving enhanced theme preference:', error);
    }
  }, [isEnhancedTheme]);

  const toggleEnhancedTheme = () => {
    setIsEnhancedTheme(prev => !prev);
  };

  return (
    <EnhancedThemeContext.Provider value={{ 
      isEnhancedTheme, 
      toggleEnhancedTheme
    }}>
      {children}
    </EnhancedThemeContext.Provider>
  );
};

export const useEnhancedTheme = () => {
  const context = useContext(EnhancedThemeContext);
  if (!context) {
    throw new Error('useEnhancedTheme must be used within an EnhancedThemeProvider');
  }
  return context;
};

export default EnhancedThemeContext;
